import { PDFData } from '@types'

export const SET_PDF_DATA = 'SET_PDF_DATA'
export const setPDFData = (pdfData: PDFData) => ({
  type: SET_PDF_DATA,
  pdfData,
})

export const CLEAR_PDF_DATA = 'CLEAR_PDF_DATA'
export const clearPDFData = () => ({
  type: CLEAR_PDF_DATA,
})
